const asset = (fileName: string) => `/special-tour-assets/${fileName}`;

export const kakaoInquiryUrl = "https://pf.kakao.com/_EPIxfG/chat";
export const phoneUrl = "tel:010-3131-2671";
export const emailUrl = "mailto:kkh960313@naver.com";
export const youtubeUrl = "https://www.youtube.com/@%EC%9D%B4%EB%81%BC%EC%A7%B1";

export type Region = {
  slug: string;
  name: string;
  season: string;
  summary: string;
  image: string;
  imageAlt: string;
  courses: string[];
  travel: string[];
};

export type Itinerary = {
  slug: string;
  region: string;
  title: string;
  subtitle: string;
  days: string[];
  notes: string[];
};

export type GalleryItem = {
  title: string;
  region: string;
  image: string;
  imageAlt: string;
  description: string;
};

export type Destination = {
  title: string;
  area: string;
  image: string;
  imageAlt: string;
  description: string;
};

export type Review = {
  title: string;
  date: string;
  people: string;
  rating: string;
  body: string;
  link?: string;
};

export type VideoStory = {
  title: string;
  location: string;
  size: string;
  description: string;
  videoSrc?: string;
  poster?: string;
  href?: string;
};

export const regions: Region[] = [
  {
    slug: "hokkaido",
    name: "홋카이도",
    season: "4월 중순 - 10월 말",
    summary:
      "맑은 공기와 넓은 페어웨이가 강점인 여름 골프 목적지입니다. 오비히로와 삿포로를 중심으로 골프와 로컬 여행을 함께 설계합니다.",
    image: asset("hokkaido-classic-course.png"),
    imageAlt: "홋카이도 클래식 골프 코스 지도",
    courses: ["홋카이도클래식GC 클래식코스", "홋카이도클래식GC 메이플코스"],
    travel: ["삿포로", "오타루", "토카치", "아바시리"],
  },
  {
    slug: "osaka",
    name: "오사카/고베",
    season: "10월 초순 - 6월 말",
    summary:
      "간사이공항 접근성이 좋고, 라운드 전후로 오사카 도심과 교토, 고베 여행을 붙이기 좋은 지역입니다.",
    image: asset("osaka-area-map.png"),
    imageAlt: "오사카 주변 골프장 지도",
    courses: ["효고현 골프장", "고베권 골프장", "타라오CC"],
    travel: ["우메다", "난바", "도톤보리", "교토", "나라"],
  },
  {
    slug: "shikoku",
    name: "시코쿠",
    season: "3월 초순 - 6월 말 · 9월 중순 - 12월 초순",
    summary:
      "마쓰야마의 도고온천과 고치의 식도락을 잇는 온난한 골프 여행지입니다. 개성 있는 해안·구릉 코스와 두 도시 체류를 한 일정으로 설계합니다.",
    image: asset("shikoku-matsuyama-dogo.jpg"),
    imageAlt: "마쓰야마 도고온천 본관",
    courses: ["고치 구로시오CC", "그린필GC", "선셋힐스CC", "오쿠도고GC"],
    travel: ["마쓰야마", "도고온천", "고치", "고치 중앙상점가", "가쓰오 요리"],
  },
  {
    slug: "kyushu",
    name: "큐슈",
    season: "10월 말 - 4월 말",
    summary:
      "구마모토, 가고시마, 미야자키를 잇는 온화한 골프 루트입니다. 온천과 화산 지형 여행을 함께 즐길 수 있습니다.",
    image: asset("kagoshima-area-map.png"),
    imageAlt: "가고시마 중심 골프장 지도",
    courses: ["가고시마 국제CC", "치란CC", "아소그랑브리오GC"],
    travel: ["후쿠오카", "구마모토", "아소산", "사쿠라지마", "이브스키"],
  },
  {
    slug: "okinawa",
    name: "오키나와",
    season: "10월 말 - 4월 말",
    summary:
      "겨울에도 따뜻한 남국 골프 목적지입니다. 나하 시내, 바다 전망 코스, 리조트형 자유여행을 연결합니다.",
    image: asset("okinawa-naha-map.png"),
    imageAlt: "오키나와 나하 골프장 및 관광지 지도",
    courses: ["NIKKI Country Club", "KISE CC", "오키나와 주변 CC"],
    travel: ["나하", "아메리칸 빌리지", "오키나와 해안 코스"],
  },
];

export const itineraries: Itinerary[] = [
  {
    slug: "hokkaido",
    region: "홋카이도",
    title: "삿포로/오비히로 3박 4일 54홀",
    subtitle: "여름 시즌에 가장 안정적인 북해도 대표 일정",
    days: [
      "1일차: 신치토세공항 도착 후 삿포로 이동",
      "2일차: 홋카이도클래식GC 오비히로 메이플코스 18홀",
      "3일차: 홋카이도클래식GC 오비히로 클래식코스 18홀 + 추가 라운드",
      "4일차: 홋카이도클래식GC 오비히로 메이플코스 18홀 후 공항 이동",
    ],
    notes: ["항공 시간에 맞춰 라운드 수 조정", "토카치/오타루/아바시리 여행 연계 가능"],
  },
  {
    slug: "osaka",
    region: "오사카/고베",
    title: "간사이 3박 4일 54홀",
    subtitle: "공항 접근성과 도시 여행을 함께 잡는 일정",
    days: [
      "1일차: 간사이공항 도착 후 골프장 이동 및 18홀",
      "2일차: 효고현/고베권 골프 코스 18홀",
      "3일차: 효고현/고베권 골프 코스 18홀",
      "4일차: 공항 주변 골프장 18홀 후 공항 이동",
    ],
    notes: ["첫째 날과 넷째 날 라운드는 항공 시간에 따라 선택", "오사카 도심, 교토, 나라 여행 연계 가능"],
  },
  {
    slug: "kyushu",
    region: "구마모토/가고시마",
    title: "큐슈 3박 4일 54홀",
    subtitle: "골프, 온천, 사쿠라지마를 함께 즐기는 남큐슈 루트",
    days: [
      "1일차: 구마모토공항 도착 후 골프장 이동 및 18홀",
      "2일차: 가고시마 국제CC 18홀",
      "3일차: 치란CC 18홀 후 이브스키 모래찜질 온천",
      "4일차: 사쿠라지마 주변 관광 후 공항 이동",
    ],
    notes: ["아소산/온천 동선 추가 가능", "미야자키 코스와 조합 가능"],
  },
  {
    slug: "okinawa",
    region: "오키나와",
    title: "나하 3박 4일 54홀",
    subtitle: "겨울에도 따뜻한 해양 골프 일정",
    days: [
      "1일차: 나하공항 도착 후 골프장 이동 및 18홀",
      "2일차: 오키나와 주변 CC 18홀",
      "3일차: KISE CC 18홀",
      "4일차: 오키나와 관광 후 공항 이동",
    ],
    notes: ["리조트 휴식형 일정으로 변경 가능", "나하 시내와 해안 관광 동선 연계 가능"],
  },
  {
    slug: "shikoku",
    region: "시코쿠 · 마쓰야마/고치",
    title: "시코쿠 3박 4일 54홀",
    subtitle: "온천과 식도락, 남국 풍경을 연결하는 두 도시 골프 루트",
    days: [
      "1일차: 마쓰야마공항 도착 후 도고온천과 마쓰야마 시내",
      "2일차: 선셋힐스CC 또는 오쿠도고GC 18홀",
      "3일차: 고치 이동 후 그린필GC 또는 니시키야마CC 18홀",
      "4일차: 고치 구로시오CC 18홀 후 고치공항 이동",
    ],
    notes: ["항공편에 따라 고치 인·마쓰야마 아웃 역방향 구성 가능", "도고온천과 고치 가쓰오 식도락 일정 연계"],
  },
];

export const courseGallery: GalleryItem[] = [
  {
    title: "홋카이도클래식GC 클래식코스",
    region: "홋카이도",
    image: asset("classic-holes-1234.png"),
    imageAlt: "홋카이도클래식GC 클래식코스 1번부터 4번 홀",
    description: "오비히로의 넓은 지형을 살린 클래식 코스입니다.",
  },
  {
    title: "홋카이도클래식GC 메이플코스",
    region: "홋카이도",
    image: asset("maple-holes-1234.png"),
    imageAlt: "홋카이도클래식GC 메이플코스 1번부터 4번 홀",
    description: "여름 북해도 골프의 시원한 풍경을 보여주는 메이플 코스입니다.",
  },
  {
    title: "오사카/타라오CC",
    region: "오사카/시가",
    image: asset("osaka-tarao.png"),
    imageAlt: "오사카와 타라오 골프장 이미지",
    description: "간사이 여행과 온천을 붙이기 좋은 골프 코스입니다.",
  },
  {
    title: "오키나와 골프 코스",
    region: "오키나와",
    image: asset("okinawa-golf-courses.png"),
    imageAlt: "오키나와 골프장 이미지 모음",
    description: "따뜻한 기후와 바다 분위기를 함께 즐기는 남국 골프입니다.",
  },
  {
    title: "가고시마 골프 코스",
    region: "가고시마",
    image: asset("kagoshima-golf-courses.png"),
    imageAlt: "가고시마 골프장 이미지 모음",
    description: "화산 지형과 온천 동선을 함께 설계할 수 있는 큐슈 코스입니다.",
  },
  {
    title: "고치 구로시오 컨트리클럽",
    region: "시코쿠 · 고치",
    image: asset("shikoku-kochi-kuroshio-cc.jpg"),
    imageAlt: "야자수와 넓은 페어웨이가 펼쳐진 고치 구로시오 컨트리클럽",
    description: "태평양의 온화한 공기와 남국 분위기를 함께 느끼는 고치 대표 코스입니다.",
  },
  {
    title: "니시키야마 컨트리클럽",
    region: "시코쿠 · 고치",
    image: asset("shikoku-nishikiyama-cc.jpg"),
    imageAlt: "소나무 사이로 그린과 벙커가 보이는 니시키야마 컨트리클럽",
    description: "수목과 벙커가 입체적으로 어우러진 고치의 전략적인 구릉 코스입니다.",
  },
  {
    title: "그린필 골프클럽",
    region: "시코쿠 · 고치",
    image: asset("shikoku-green-feel-gc.jpg"),
    imageAlt: "연못과 산 능선이 어우러진 그린필 골프클럽",
    description: "산 능선을 배경으로 연못과 굴곡 있는 페어웨이를 즐기는 전망 좋은 코스입니다.",
  },
  {
    title: "선셋힐스 컨트리클럽",
    region: "시코쿠 · 마쓰야마",
    image: asset("shikoku-sunset-hills-cc.jpg"),
    imageAlt: "연못과 야자수가 보이는 선셋힐스 컨트리클럽",
    description: "리조트형 클럽하우스와 연못 풍경이 인상적인 마쓰야마 근교 코스입니다.",
  },
  {
    title: "오쿠도고 골프클럽",
    region: "시코쿠 · 마쓰야마",
    image: asset("shikoku-okudogo-gc.jpg"),
    imageAlt: "마쓰야마 시내와 세토내해를 내려다보는 오쿠도고 골프클럽",
    description: "마쓰야마 시내와 세토내해를 내려다보는 탁 트인 전망이 강점인 코스입니다.",
  },
];

export const destinations: Destination[] = [
  {
    title: "도고온천",
    area: "시코쿠 · 마쓰야마",
    image: asset("shikoku-matsuyama-dogo.jpg"),
    imageAlt: "저녁의 마쓰야마 도고온천 본관",
    description: "라운드 후 온천과 상점가 산책을 함께 즐기기 좋은 마쓰야마의 대표 명소입니다.",
  },
  {
    title: "고치 중앙상점가",
    area: "시코쿠 · 고치",
    image: asset("shikoku-kochi-city.jpg"),
    imageAlt: "밤의 고치 중앙상점가 아케이드",
    description: "가쓰오 요리와 이자카야를 걸어서 즐길 수 있는 고치 시내 체류의 중심입니다.",
  },
  {
    title: "NIKKI Country Club",
    area: "오키나와",
    image: asset("golf-course-okinawa.jpg"),
    imageAlt: "오키나와 골프장",
    description: "JPGA 챔피언십 개최지로 알려진 오키나와 대표 골프 목적지입니다.",
  },
  {
    title: "사쿠라지마",
    area: "가고시마",
    image: asset("sakurajima.jpg"),
    imageAlt: "가고시마 사쿠라지마",
    description: "가고시마 일정에 강한 인상을 남기는 신비로운 화산섬입니다.",
  },
  {
    title: "이브스키 스나무시",
    area: "가고시마",
    image: asset("ibusuki-sand-bath.jpg"),
    imageAlt: "이브스키 검은 모래찜질",
    description: "라운드 후 피로를 풀기 좋은 검은 모래찜질 온천 체험입니다.",
  },
  {
    title: "타라오CC와 온천",
    area: "시가현",
    image: asset("tarao-country-club.png"),
    imageAlt: "타라오 컨트리클럽",
    description: "오사카권 여행에 온천 휴식을 더하는 코스입니다.",
  },
  {
    title: "아소그랑브리오GC",
    area: "구마모토",
    image: asset("aso-grandvrio.png"),
    imageAlt: "아소그랑브리오 골프장",
    description: "아소 국립공원 분위기와 함께 즐기는 큐슈 골프 코스입니다.",
  },
  {
    title: "아바시리 류효 여객선",
    area: "홋카이도",
    image: asset("abashiri-icebreaker.png"),
    imageAlt: "아바시리 류효 여객선",
    description: "겨울 북해도 여행에 넣기 좋은 바다얼음 체험 코스입니다.",
  },
];

export const reviews: Review[] = [
  {
    title: "최고의 코스와 가이드의 완벽한 지원",
    date: "2024년 12월 셋째 주",
    people: "8명",
    rating: "9.0/10",
    body:
      "홋카이도는 겨울뿐만 아니라 골프 여행지로도 최고였습니다. 조용하고 깨끗한 자연 환경 속에서 플레이하는 기분이 정말 색달랐고, 현지 맛집과 레슨까지 만족스러웠습니다.",
    link: "https://www.notion.so/173098d9401d80d1b3c5c485544d53ec",
  },
  {
    title: "현지 동선까지 맡길 수 있는 여행",
    date: "단체 맞춤 일정",
    people: "소규모/단체",
    rating: "맞춤 추천",
    body:
      "골프만 치는 일정이 아니라 지역 음식, 온천, 자유여행을 팀 성향에 맞춰 함께 짜 주는 점이 스페셜투어의 강점입니다.",
  },
  {
    title: "라운드 이후 시간이 더 좋아지는 투어",
    date: "골프 + 자유여행",
    people: "가족/지인",
    rating: "재문의 추천",
    body:
      "라운드 후 이자카야, 온천, 시내 산책까지 이어지는 일정이라 동행자 모두가 각자 원하는 방식으로 여행을 즐길 수 있습니다.",
  },
];

export const videoStories: VideoStory[] = [
  {
    title: "2024년 스페셜투어 이모저모",
    location: "후쿠오카, 홋카이도, 오사카",
    size: "원본 약 309MB",
    description: "2024년 주요 팀 여행과 라운드 분위기를 모은 영상입니다.",
  },
  {
    title: "오사카 라쿠라쿠엔 40주년 라스트 컴페",
    location: "오사카",
    size: "원본 약 113MB",
    description: "단체 컴페 일정의 흐름과 현장 분위기를 보여주는 기록 영상입니다.",
  },
  {
    title: "후쿠오카 골프투어",
    location: "텐잔CC, 사이칸위너스, 타케오우레시노",
    size: "원본 약 229MB",
    description: "후쿠오카 골프와 온천 동선을 함께 담은 팀 여행 영상입니다.",
  },
  {
    title: "GS CLUB 골프투어",
    location: "2026년 5월, GS CLUB",
    size: "웹용 약 68MB / 원본 약 936MB",
    description: "최춘집 5P 팀의 GS CLUB 라운드 분위기를 홈페이지에서 바로 확인할 수 있는 영상입니다.",
    videoSrc: "/special-tour-assets/gs-club-tour-2026-web.mp4",
    poster: "/special-tour-assets/gs-club-tour-2026-cover.jpg",
  },
  {
    title: "夏山 & 西村 골프투어",
    location: "2026년 6월 9일",
    size: "웹용 약 44MB / 원본 약 741MB",
    description: "여름 라운드 분위기와 팀 여행 장면을 홈페이지에서 바로 확인할 수 있는 후기 영상입니다.",
    videoSrc: "/special-tour-assets/tour-review-natsuyama-nishimura-2026-0609-web.mp4",
    poster: "/special-tour-assets/tour-review-natsuyama-nishimura-2026-0609-cover.jpg",
  },
  {
    title: "웅지15골친회 골프투어",
    location: "2026년 6월 5일",
    size: "웹용 약 33MB / 원본 약 565MB",
    description: "웅지15골친회 팀의 골프투어 현장 분위기를 담은 후기 영상입니다.",
    videoSrc: "/special-tour-assets/tour-review-woongji15-2026-0605-web.mp4",
    poster: "/special-tour-assets/tour-review-woongji15-2026-0605-cover.jpg",
  },
];

export const contactItems = [
  { label: "카카오톡 문의", value: "스페셜투어 채널", href: kakaoInquiryUrl },
  { label: "전화", value: "010-3131-2671", href: phoneUrl },
  { label: "이메일", value: "kkh960313@naver.com", href: emailUrl },
  { label: "홈페이지", value: "www.special-tour.golf", href: "https://www.special-tour.golf" },
  { label: "YouTube", value: "youtube.com/@이끼짱", href: youtubeUrl },
];
